import http from "./http-common";
import Training from "../types/Training"

class TrainingDataService {

    async getByUserId(userId: number) {
      const response = await http.get(`/trainings/user/${userId}`);
      return response.data as Training[];
    }

    getAll() {
      return http.get("/trainings").then((response) => response.data).catch(error => {throw error});
    }

    getByDateForRangeAndUser(userId: number, startDate: Date, endDate: Date)
    {
      const startDateStr = startDate.toISOString(); //.split('T')[0];
      const endDateStr = endDate.toISOString(); //.split('T')[0];
      return http.get(`/trainings/user/${userId}/daterange`, {
        params: {
          startDate: startDateStr,
          endDate: endDateStr,
        },
      })
      .then((response) => response.data as Training[])
      .catch((error) => {
        throw error;
      });
    };
  
    getById(id : number) {
      return http.get(`/training/${id}`).then((response) => response.data).catch(error => {throw error});
    }
  
    add(data : Training) {
      console.log("save training (insert):" + JSON.stringify(data));
      return http.post("/training", data).then((response) => response.data).catch(error => {throw error});
    }
  
    update(data : Training) {
      console.log("save training (update):" + JSON.stringify(data));
      return http.put(`/training/${data.id}`, data).then((response) => response.data).catch(error => {throw error});
    }
  
    deleteById(id : number) {
      return http.delete(`/training/${id}`).then((response) => id).catch(err => { throw err});
    }
  
    deleteAll() {
      return http.delete("/training").catch(error => {  throw error});
    }
  
    findByName(name : String, feedback : any) {
      return http.get(`/training?name=${name}`);
    }

    getWeeklySummaries(userId: number, startDate: Date, endDate: Date) {
      const startDateStr = startDate.toISOString(); // Full ISO format
      const endDateStr = endDate.toISOString(); // Full ISO format
      return http
        .get(`/trainings/user/${userId}/weekly-summary`, {
          params: {
            startDate: startDateStr,
            endDate: endDateStr,
          },
        })
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        });
    }

  }

  const trainingDataServiceInst = new TrainingDataService();
  
  export default trainingDataServiceInst;